import { createSelector } from '@ngrx/store';
import { RoleStateInterface, selectAll } from './role.state';
import { getRoleState } from '../setting.selectors';

export const getAllRoles = createSelector(
  getRoleState,
  (state: RoleStateInterface) => selectAll(state)
);
